import type { ReactNode } from "react";
import type { Services } from "@/lib/services";
import { ServicesContext } from "./services-context";

interface ServicesProviderProps {
  readonly services: Services;
  readonly children: ReactNode;
}

export function ServicesProvider({ services, children }: ServicesProviderProps) {
  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
}
